import { Link } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";

/**
 * FeatureCard — modular feature highlight (analyzer, world cup hub, etc.)
 * status: "live" | "soon"
 */
export const FeatureCard = ({
  icon: Icon,
  title,
  description,
  status = "soon",
  to,
  testId,
}) => {
  const Wrapper = to ? Link : "div";
  const wrapperProps = to ? { to } : {};

  return (
    <Wrapper
      {...wrapperProps}
      data-testid={testId}
      className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-brand-navy bg-brand-navy/30 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand-royal/60 hover:bg-brand-navy/50"
    >
      <div className="mb-5 flex items-center justify-between">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-brand-royal/30 bg-brand-bg text-brand-cyan transition-colors duration-300 group-hover:border-brand-cyan/60">
          {Icon && <Icon className="h-6 w-6" />}
        </div>
        <span
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-mono-data text-[10px] font-semibold uppercase tracking-wider ${
            status === "live"
              ? "bg-brand-cyan/15 text-brand-cyan"
              : "bg-brand-navy text-brand-silver"
          }`}
        >
          {status === "soon" && <Lock className="h-3 w-3" />}
          {status === "live" ? "Live" : "Phase 2"}
        </span>
      </div>

      <h3 className="font-display text-xl font-semibold tracking-tight text-white">
        {title}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-silver">
        {description}
      </p>

      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-brand-cyan opacity-0 transition-all duration-300 group-hover:opacity-100">
        Explore
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </Wrapper>
  );
};

export default FeatureCard;
